import { Alert, Button, Checkbox, Col, Form, Input, InputNumber, Modal, Radio, Row, Table, Tooltip } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import { MapContainer, TileLayer, useMap, Circle } from 'react-leaflet';
import LocationSelector from './LocationSelector';
import 'leaflet/dist/leaflet.css'
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import SearchControl from './SearchControl';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

function MapInvalidateSize({ trigger }) {
    const map = useMap();
    useEffect(() => {
        if (trigger) {
            setTimeout(() => {
                map.invalidateSize();
            }, 200);
        }
    }, [trigger, map]);
    return null;
}

function AttendanceLocation() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [form] = Form.useForm();

    const [inputMode, setInputMode] = useState('map');

    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        sorter: {
            order: 'descend',
            columnKey: 'attendance_location_id',
        }
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState('');

    const titlePage = 'Attendance Location Data';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            render: (id, record, index) => {
                return (page.pagination.current - 1) * page.pagination.pageSize + index + 1;
            },
        },
        {
            title: 'Location Name',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
        },
        {
            title: 'Set Name',
            dataIndex: 'name_set',
            key: 'name_set',
            sorter: true,
        },
        {
            title: 'Latitude',
            dataIndex: 'latitude',
            key: 'latitude',
        },
        {
            title: 'Longitude',
            dataIndex: 'longitude',
            key: 'longitude',
        },
        {
            title: 'Radius (m)',
            dataIndex: 'radius',
            key: 'radius',
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (value) => (value ? 'Fixed' : 'Flexible'),
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Tooltip title="Edit">
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                            <EditOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                            <DeleteOutlined />
                        </Button>
                    </Tooltip>
                </>
            ),
        },
    ];

    useEffect(() => {
        const order = page.sorter?.order === 'ascend' ? 'asc' : 'desc';
        const columnKey = page.sorter?.columnKey || 'attendance_location_id';

        getApi("GET", `/attendancelocation?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}`, 'attendancelocation');

        if (dataModal) {
            const lat = parseFloat(dataModal.latitude);
            const lng = parseFloat(dataModal.longitude);
            if (!isNaN(lat) && !isNaN(lng)) {
                form.setFieldsValue({ latitude: lat, longitude: lng });
            }
        }
    }, [JSON.stringify(page), dataModal, isAlert]);

    const getApi = (method, url) => {
        setLoading(true);
        const dataReq = {
            method,
            url,
            data: {
                headers: { Authorization: 'Bearer ' + token }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setData(res.data.data);
                setPage(prev => ({
                    ...prev,
                    pagination: { ...prev.pagination, total: res.data.total_data }
                }));
                setLoading(false);
            } else {
                setLoading(false);
            }
        }).catch(e => {
            setLoading(false);
            console.error(e.message);
        });
    };

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method,
            url,
            data: {
                data: values,
                headers: { Authorization: 'Bearer ' + token }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setdataModal(null);
                setLoading(false);
                setIsAlert(true);
                setTextAlert(res.message);
                closeModal();
            } else {
                setLoading(false);
                modalError(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            console.error(e.message);
        });
    };

    const modalDeleteData = (v) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Are you sure you want to delete this data?',
            onOk: () => postApi('DELETE', `/attendancelocation/${v.attendance_location_id}`, null),
        });
    };

    const openModal = (type, data) => {
        if (type === 'edit' && data) {
            setdataModal(data);
            form.setFieldsValue({
                name: data.name,
                name_set: data.name_set,
                latitude: data.latitude,
                longitude: data.longitude,
                type: data.type,
                radius: data.radius
            });
        } else {
            setdataModal(null);
            form.resetFields();
        }
        setIsModal(true);
    };

    const onFinish = (ev) => {
        ev.latitude = ev.latitude.toFixed(6).toString();
        ev.longitude = ev.longitude.toFixed(6).toString();
        if (dataModal) {
            postApi("PUT", `/attendancelocation/${dataModal.attendance_location_id}`, ev);
        } else {
            postApi("POST", '/attendancelocation', ev);
        }
    };

    const closeModal = () => {
        setdataModal(null);
        setIsModal(false);
        form.resetFields();
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: { current: 1, pageSize: 10 },
            sorter: {},
        });
    };

    // Ambil nilai realtime dari form
    const lat = form.getFieldValue('latitude') || -6.2;
    const lng = form.getFieldValue('longitude') || 106.8;
    const radiusValue = form.getFieldValue('radius') || 0;

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Attendance Location</h3>
            <Row>
                <Col span={8}>
                    <Search
                        placeholder="Search"
                        allowClear
                        enterButton="Search"
                        size="middle"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Button style={{ marginBottom: 10 }} type="primary" onClick={() => openModal('add', null)}>
                        <PlusOutlined />
                        <b style={{ marginLeft: 5 }}>Add</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
                rowKey="attendance_location_id"
            />
            <Modal title="Attendance Location Form" width={900} open={isModal} onOk={form.submit} onCancel={closeModal} okText="Save">
                <Form form={form} name="form" layout="vertical" onFinish={onFinish} initialValues={{ type: false }}>
                    <Form.Item
                        name="name"
                        label="Location Name"
                        rules={[{ required: true, message: 'Location Name is required!' }]}
                    >
                        <Input placeholder="e.g. Head Office" />
                    </Form.Item>

                    <Form.Item
                        name="name_set"
                        label="Location Set Name"
                        rules={[{ required: true, message: 'Location Set Name is required!' }]}
                    >
                        <Input placeholder="e.g. Building A" />
                    </Form.Item>
                    <Form.Item label="Select Location Mode">
                        <Radio.Group
                            value={inputMode}
                            onChange={e => setInputMode(e.target.value)}
                            optionType="button"
                            buttonStyle="solid"
                        >
                            <Radio.Button value="map">Map</Radio.Button>
                            <Radio.Button value="input">Input Latitude & Longitude</Radio.Button>
                        </Radio.Group>
                    </Form.Item>

                    {inputMode === 'map' ? (
                        <>

                            <MapContainer
                                key={`${lat}-${lng}`}  // agar map reload setiap ganti lokasi
                                center={[lat, lng]}
                                zoom={13}
                                style={{ height: '300px', zIndex: 0 }}
                            >
                                <MapInvalidateSize trigger={isModal && inputMode === 'map'} />
                                <TileLayer
                                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />

                                <LocationSelector
                                    position={[lat, lng]}
                                    onChange={(latlng) => {
                                        form.setFieldsValue({
                                            latitude: latlng.lat,
                                            longitude: latlng.lng,
                                        });
                                    }}
                                />
                                <SearchControl
                                    key={`search-${lat}-${lng}`}
                                    onSearchResult={(latlng) => {
                                        form.setFieldsValue({
                                            latitude: latlng.lat,
                                            longitude: latlng.lng,
                                        });
                                    }}
                                />

                                {/* Circle radius */}
                                {radiusValue > 0 && (
                                    <Circle
                                        center={[lat, lng]}
                                        radius={radiusValue}  // radius dalam meter
                                        pathOptions={{ color: 'blue', fillColor: 'blue', fillOpacity: 0.2 }}
                                    />
                                )}
                            </MapContainer>

                            <Form.Item name="latitude" hidden>
                                <Input />
                            </Form.Item>
                            <Form.Item name="longitude" hidden>
                                <Input />
                            </Form.Item>
                        </>
                    ) : (
                        <>
                            <Form.Item
                                name="latitude"
                                label="Latitude"
                                rules={[{ required: true, message: 'Latitude is required!' }]}
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={-90}
                                    max={90}
                                    step={0.000001}
                                    placeholder="Enter Latitude"
                                    controls={false}
                                />
                            </Form.Item>

                            <Form.Item
                                name="longitude"
                                label="Longitude"
                                rules={[{ required: true, message: 'Longitude is required!' }]}
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={-180}
                                    max={180}
                                    step={0.000001}
                                    placeholder="Enter Longitude"
                                    controls={false}
                                />
                            </Form.Item>
                        </>
                    )}

                    <Form.Item
                        name="radius"
                        label="Radius (meter)"
                        rules={[{ required: true, message: 'Radius is required!' }]}
                    >
                        <InputNumber
                            style={{ width: '100%' }}
                            placeholder="Enter Radius"
                        />
                    </Form.Item>
                    <Form.Item
                        name="type"
                        label="Location Type"
                        valuePropName="checked"
                        tooltip="Check if the location is fixed"
                    >
                        <Checkbox>Fixed Location</Checkbox>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default AttendanceLocation;
